export const useCreateActivityFromTemplate = () => {
  const activityTemplateId: string = ""; 
  
  const createActivityFromTemplate = (title: string) => {
    console.log(`[useCreateActivityFromTemplate] - user clicked create on the Create Activity Dialog with \ntitle = '${title}' \ntemplate with activityId = ${activityTemplateId}`);
  }

  return createActivityFromTemplate;
}